const hasSessionInStore = () => {
    //Check for an existing session in sessionStorage.. only checking for one prop
    return sessionStorage.getItem('SessionToken') ? true : false;
}

const getSessionStoreValues = () => {
    return hasSessionInStore()
        ? {
            LoginTimeStamp: sessionStorage.getItem('LoginTimeStamp'),
            PlayerID: sessionStorage.getItem('PlayerID'),
            PlayerName: sessionStorage.getItem('PlayerName'),
            SessionToken: sessionStorage.getItem('SessionToken')
        }
        : null;
}

const updateSessionStore = (ngSession, currentSessionStoreValues) => {

    var requestObject = {
        playerId: "",
        sessionToken: ""
    };

    if (!ngSession) {
        sessionStorage.removeItem('LoginTimeStamp');
        sessionStorage.removeItem('PlayerID');
        sessionStorage.removeItem('PlayerName');
        sessionStorage.removeItem('SessionToken');
    } else {
        if (ngSession.LoginTimeStamp) {
            sessionStorage.setItem('LoginTimeStamp', ngSession.LoginTimeStamp);
        }

        if (ngSession.PlayerID) {
            sessionStorage.setItem('PlayerID', ngSession.PlayerID);
            requestObject.playerId = ngSession.PlayerID;
        }

        if (ngSession.PlayerName) {
            sessionStorage.setItem('PlayerName', ngSession.PlayerName);
        }

        if (ngSession.SessionToken) {
            sessionStorage.setItem('SessionToken', ngSession.SessionToken);
            requestObject.sessionToken = ngSession.SessionToken;
        }

    }

    //Communicate session info to server
    postSessionValues(requestObject, ngSession, currentSessionStoreValues);
}

const postSessionValues = (requestObject, ngSession, previousSessionStoreValues) => {

    $.ajax({
        url: '/api/v1/updatesessionuser',
        type: 'POST',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {

            if (isNaN(parseInt(data.MatchId))) {
                sessionStorage.removeItem('GameroomID');
            } else {
                sessionStorage.setItem('GameroomID', parseInt(data.MatchId));
            }

            if (data.ShowAlertsModal) {
                $('#alert-user-id').val(data.MatchId);
                $('#alert-email').val(data.EmailAddress);
            }

            emitSessionStatusChangeEvent(ngSession, previousSessionStoreValues, data.ShowAlertsModal)
        });
}

const emitSessionStatusChangeEvent = (ngSession, previousSessionStore, showAlertsModal) => {

    //Get values currently in SessionStorage
    //let sessionStore = getSessionStoreValues();

    //Based on values in ngSession vs SessionStorage, determine current SessionState
    let currentState = getCurrentSessionState(ngSession, previousSessionStore /*sessionStore*/);

    //Emit event for the currentState
    var event = new CustomEvent(currentState, { detail: { showAlertSignup: showAlertsModal } });
    document.dispatchEvent(event);
}

const getSessionDetails = () => {
    return ng_fw.getSessionDetails();
}

const getCurrentSessionState = (ngSession, sessionStore) => {

    if (!sessionStore && !ngSession) { return "LOGGEDOUT"; }
    else if (!sessionStore && ngSession) { return "LOGGINGIN"; }
    else if (sessionStore && ngSession) { return "LOGGEDIN"; }
    else if (sessionStore && !ngSession) { return "LOGGINGOUT"; }

}

const updateWPTopBarItems = (session) => {
    if (session) {
        hidePreLoginItems();
        showWelcomeMessage(session.PlayerName);
        showLogoutLink();
		//showLiveChat(); // RCW 10/22/19
		} 
		else {
        hideWelcomeMessage();
        hideLogoutLink();
        showPreLoginItems();
		//hideLiveChat();// RCW 10/22/19
    }
}

const showWelcomeMessage = (playerName) => {
    $('#wp-welcome-message').removeClass('hidden');
    $('#wp-welcome-message #loggedin-user-displayname').html(playerName);
    $('#play-online-link').removeClass('should-flex');
}
const hideWelcomeMessage = () => {
    $('#wp-welcome-message').addClass('hidden');
    $('#wp-welcome-message #loggedin-user-displayname').html("");
    $('#play-online-link').addClass('should-flex');
}

const showLogoutLink = () => {
    $('#wp-logout-link').removeClass('hidden');
    $('#my-account-link').removeClass('hidden');
}
const hideLogoutLink = () => {
    $('#wp-logout-link').addClass('hidden');
    $('#my-account-link').addClass('hidden');
}

const showPreLoginItems = () => {
	$('#wp-float-chat').addClass('hidden');
    $('#wp-login-link').removeClass('hidden');
    $('#wp-register-link').removeClass('hidden');
}
const hidePreLoginItems = () => {
	$('#wp-float-chat').removeClass('hidden');
    $('#wp-login-link').addClass('hidden');
    $('#wp-register-link').addClass('hidden');
}

//SHOPPING CART
//Note: Shopping cart is split out because it requires ng_fw to be available
const updateWPTopBarCart = (session) => {
    if (session) {
        showShoppingCartItem();
        initCartPreviewContainer();
		ng_fw.keepAlive();
	
		} 
		else 
		{
       // hideShoppingCartItem();
	   showShoppingCartItem();
       initCartPreviewContainer();
    }
}
const showShoppingCartItem = () => {
    $('#wp-shopping-cart').removeClass('hidden');
	
    //Request shopping cart status through the NG framework API
    var status = ng_fw.getShoppingCartStatus();
    //console.log("ShoppingCart Status: ", status);

    //Update cart items counter based on cart status
    $('#wp-shopping-cart #shopping-cart-item-counter').html(status.IsError ? '!' : `(${status.NumberOfItems})`);

    var currentBalance = ng_fw.getDisplayBalance();
    //console.log("ShoppingCart Balance: ", currentBalance);
}
const hideShoppingCartItem = () => {
    $('#wp-shopping-cart').addClass('hidden');
}
const initCartPreviewContainer = () => {
    var btnCartPreview_Popover = $('.wp-cart-preview-popover');
    var popcart_timeout;

    $('#wp-shopping-cart').hover(function () {
        window.clearTimeout(popcart_timeout);

        //Show cart preview popover on preview container hover
        if (!btnCartPreview_Popover.is(":visible")) { showCartPreviewPopover(); }

    }, function () {
        window.clearTimeout(popcart_timeout);

        //Hide cart preview popover on preview container hover out
        popcart_timeout = window.setTimeout(function () { hideCartPreviewPopover(); }, 500);
    });

    //Use animation to show cart preview popover
    function showCartPreviewPopover() {
        btnCartPreview_Popover
            .stop()
            .show()
            .css({ opacity: 0 })
            .animate({ opacity: 1 }, '200');
    }

    //Use animation to hide cart preview popover
    function hideCartPreviewPopover() {
        btnCartPreview_Popover
            .stop()
            .animate({ opacity: 0 }, '200', function () { btnCartPreview_Popover.hide(); });
    }

    //Hide cart preview popover on close button click
    $(".wp-cart-preview-popover-close-btn").on("click", hideCartPreviewPopover); 
}
const showLiveChat = (session) => 
{
    //Show chat button   
	$('#wp-float-chat').removeClass('hidden');
	 //$('#wp-welcome-message').removeClass('hidden');
    //$('#wp-welcome-message #loggedin-user-displayname').html(playerName);
	try{
    var status = ng_fw.showChat();
    console.log("LiveChat Status: ", status);
	}catch(e){console.log("showLiveChat Error "+e.message);}
}
const hideLiveChat = () => 
{
 //Hide chat button   
   $('#wp-float-chat').addClass('hidden');
}

//ALERT SIGNUP MODAL
const showAlertSignupModal = () => {
    $('#alert-signup-modal').modal("show");
}

module.exports = {
    SessionStore: {
        updateSessionStore: updateSessionStore,
        getSessionDetails: getSessionDetails,
        hasSessionInStore: hasSessionInStore,
        getSessionStoreValues: getSessionStoreValues,
        emitSessionStatusChangeEvent: emitSessionStatusChangeEvent
    },
    Display: {
        updateWPTopBarItems: updateWPTopBarItems,
        updateWPTopBarCart: updateWPTopBarCart,
        showAlertSignupModal: showAlertSignupModal
    }
};    

//Keep Alive Function call -- 10/01/2019 
/*const WPKeepAlive = (session) => {
    if (session) {
    
	
        //Keep player alive
        ng_fw.keepAlive();
		alert("hey Ray, This is the Keep Alive function");
    
	}
}*/


/*To open Login popup for Edge- Added by RAJU/Feb 21,2019*/

 //$(document).ready(function () {
        
        //$("[id$='login-link'],.mwc-reg-sign-in-link").on('click', function () {
           // console.log('login start for: ' + $(this).attr('id'));
            //ng_fw.showLogin();
       // });
        
        //$("[id$='register-link'],.mwc-login-registration-link").on('click', function () {
            //console.log('register start for: ' + $(this).attr('id'));
            //ng_fw.showRegistration();
       // });
    //});


// WEBPACK FOOTER //
// ./shared/scripts/webportal.js